<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101323"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')">
            <el-input v-model="editDialog.form.unitId" no="unitId" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')">
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DefaultOrNot')">
            <el-radio-group v-model="editDialog.form.ifDefault" no="ifDefault" @change="onDefaultChange">
              <el-radio :label="true" style="float:left">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
              <el-radio :label="false" style="float:left">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Information.BusinessType')">
            <el-checkbox v-model="editDialog.form.seaFreight" no="seaFreight">{{ $t('CargoMsg.Cargo_OceanFreight') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.airFreight" no="airFreight">{{ $t('CargoMsg.Cargo_Air') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaSea" no="fbaSea">{{ $t('CargoMsg.Cargo_FbaSea') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaAir" no="fbaAir">{{ $t('CargoMsg.Cargo_FbaAir') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.fbaRailway" no="fbaRailway">{{ $t('CargoMsg.Cargo_FbaRailway') }}</el-checkbox>
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="editDialog.form.chargeUnit" no="chargeUnit">{{ $t('SeaExport.MeasureCurrency') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.unit" no="unit">{{ $t('CargoMsg.Cargo_Unit') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.specifyBoxType" no="unit" @change="specifyBoxTypeChange">{{ $t('CargoMsg.Cargo_BoxType2') }}</el-checkbox>
          </el-form-item>
          <el-form-item v-if="editDialog.form.specifyBoxType" :label="$t('CargoMsg.Cargo_BoxTypeAndCategory')">
            <div style="width: 200px;display: flex;">
              <cargo-advance-select
                no="eqSize"
                :select-type="selectTypeNames.local_cache_EQSize3"
                :fields="['code']"
                filterable
                :placeholder="' '"
                :show-copy="false"
                :default-value="editDialog.form.eqSize"
                style="width: 100px;"
                tag-name="code"
                @parentCallBack="p => {editDialog.form.eqSize = p.value}"
              />
              <cargo-advance-select
                no="eqType"
                :select-type="selectTypeNames.basic_data_EQType"
                :fields="['code']"
                filterable
                :placeholder="' '"
                :show-copy="false"
                :default-value="editDialog.form.eqType"
                style="width: 100px;"
                tag-name="code"
                @parentCallBack="p => {editDialog.form.eqType = p.value}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="editDialog.form.remake" no="remake" :placeholder="$t('CargoMsg.Cargo_RuleNotesTip')" type="textarea" :row="2" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChargeUnitList, saveChargeUnit, delChargeUnit, checkChargeUnits } from '@/api/basicData/chargeUnit'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { updateBasicDataForSingle } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'ChargeUnit',
  components: { CargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      selectTypeNames: TYPE_NAMES,
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'unitId',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remake',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.MeasureCurrency'),
          field: 'chargeUnit',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Unit'),
          field: 'unit',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OceanFreight'),
          field: 'seaFreight',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Air'),
          field: 'airFreight',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FbaSea'),
          field: 'fbaSea',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FbaAir'),
          field: 'fbaAir',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FbaRailway'),
          field: 'fbaRailway',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultOrNot'),
          field: 'ifDefault',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          unitId: '',
          code: '',
          chineseName: '',
          englishName: '',
          chargeUnit: '',
          unit: '',
          seaFreight: '',
          airFreight: '',
          fbaSea: '',
          fbaAir: '',
          fbaRailway: '',
          ifDefault: '',
          specifyBoxType: '',
          eqSize: '',
          eqType: '',
          remake: ''
        }
      },
      sourceCode: ''
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    specifyBoxTypeChange(e) {
      if (!this.editDialog.form.specifyBoxType) {
        this.editDialog.form.eqSize = ''
        this.editDialog.form.eqType = ''
      } else {
        const code = this.editDialog.form.code
        if (code) {
          if (code.length >= 2) {
            const eqSizeValue = code.substring(0, 2)
            const eqSize = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_EQSize3, 'code', eqSizeValue, 'code')
            if (eqSize) {
              this.editDialog.form.eqSize = eqSize
            }
          }
          if (code.length >= 4) {
            const eqTypeValue = code.slice(-2)
            const eqType = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_EQType, 'code', eqTypeValue, 'code')
            if (eqType) {
              this.editDialog.form.eqType = eqType
            }
          }
        }
      }
    },
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getChargeUnitList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          unitId: '',
          code: '',
          chineseName: '',
          englishName: '',
          chargeUnit: '',
          unit: '',
          remake: '',
          seaFreight: true,
          airFreight: true,
          fbaSea: true,
          fbaAir: true,
          fbaRailway: true,
          specifyBoxType: false,
          eqSize: '',
          eqType: '',
          ifDefault: false
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_ChargeUnit')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.sourceCode = this.editDialog.form.code
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_ChargeUnit')
      }
      this.editDialog.visible = true
    },
    onDefaultChange(val) {
      this.editDialog.form.ifDefault = val
    },
    async save() {
      const self = this
      const form = self.editDialog.form
      if (form.code === '') {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.codeCheck'))
        return
      }
      if (form.chineseName === '') {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.chineseNameCheck'))
        return
      }
      if (form.englishName === '') {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.englishNameCheck'))
        return
      }
      if (!form.chargeUnit && !form.unit) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.chargeUnitAndUnitCheck'))
        return
      }
      if (!form.seaFreight && !form.airFreight && !form.fbaSea && !form.fbaAir && !form.fbaRailway) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.businessTypeCheck'))
        return
      }
      if (form.specifyBoxType && !form.eqSize) {
        self.$message.warning(self.$t('CargoMsg.Cargo_CheckBoxSize'))
        return
      }
      if (form.uuid && this.sourceCode !== form.code) {
        const loading = getLoading()
        let checkResult = 0
        await checkChargeUnits([form.uuid]).then((res) => {
          checkResult = res.data
        }).finally(() => loading.close())
        if (checkResult === 1) {
          self.$message.warning(self.$t('Message.FeesHaveBeenUsedForEditUnit'))
          return
        }
        if (checkResult === 2) {
          self.$message.warning(self.$t('Message.TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit'))
          return
        }
      }
      const loading = getLoading()
      saveChargeUnit(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        if (res.data) {
          updateBasicDataForSingle(basicCacheKeys.basic_data_ChargeUnit, res.data)
        }
        self.toQuery()
        self.editDialog.visible = false
        this.sourceCode = ''
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
        this.sourceCode = ''
      }).finally(() => loading.close())
    },
    async remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const checkResult = await self.checkChargeUnit(rows)
      console.log(checkResult)
      if (checkResult === 1) {
        self.$message.warning(self.$t('Message.FeesHaveBeenUsedForThisUnit'))
        return
      }
      if (checkResult === 2) {
        self.$message.warning(self.$t('Message.TheChargingUnitIsUsedByAnExistingChargePlan'))
        return
      }

      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delChargeUnit(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    async checkChargeUnit(rows) {
      const uuids = []
      for (let i = 0; i < rows.length; i++) {
        uuids.push(rows[i].uuid)
      }
      let exist = 0
      const resultDatas = await checkChargeUnits(uuids)
      exist = resultDatas.data
      // await checkChargeUnits(uuids).then(res => {
      //   exist = res.data
      // }).catch(() => {})

      return exist
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style>
</style>
